import { render, staticRenderFns } from "./AnnotationPreview.vue?vue&type=template&id=a37d5e4e&scoped=true"
import script from "./AnnotationPreview.vue?vue&type=script&lang=js"
export * from "./AnnotationPreview.vue?vue&type=script&lang=js"
import style0 from "./AnnotationPreview.vue?vue&type=style&index=0&id=a37d5e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37d5e4e",
  null
  
)

export default component.exports